module.exports = __webpack_public_path__ + "img/month.bbb7b718.jpg";